import type {
  EventLookupByType as UserEventLookupByType,
  EventType as UserEventType,
  Event as UserEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import { createEventQueryObject } from "./createEventQueryObject"

const defaultSelector = {}

// adds "event_type" selector to event query
export function createEventQueryObjectForType<T extends UserEventType>(
  accountId: number | undefined,
  activityType: T,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<UserEvent>,
) {
  return createEventQueryObject(
    accountId,
    {
      selector: {
        event_type: { $eq: activityType },
        ...(selector ?? defaultSelector),
      },
      sort,
      limit,
    },
  ) as MangoQuery<UserEventLookupByType<T>> & MangoQuery<UserEvent>
}
